import { HttpInterceptorFn } from '@angular/common/http';
import { tap, catchError, EMPTY } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { routes } from '../../app/app.routes';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  
  return next(req).pipe(
    tap({
      error: (error) => {
        if (error.status === 401) {
          authService.clearAuthToken();
          const currentUrl = router.url;
          const isProtected = routes.some(route => 
            route.canActivate && currentUrl.includes(`/${route.path}`)
          );
          if (isProtected) {
            router.navigateByUrl('/login');
          }
        }
      }
    }),
    catchError((error) => {
      // Suppress 401 errors from reaching components (silent logout)
      if (error.status === 401) { return EMPTY }
      throw error;
    })
  );
};

